import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.TogglePanel,
  title: 'Toggle Panel',
  category: ComponentCategory.Layout,
  droppable: true,
  showInLibrary: false,
};
